module.exports = __webpack_public_path__ + "img/1903.b800a01d.png";